import SvgIcon from "@mui/material/SvgIcon";

const NotDataIcon = ({ fill = "#231F20", color = "#fff", ...props }) => {
    return (
        <SvgIcon
            viewBox="0 0 265 271"
            {...props}
            style={{
                width: props.width || "100%",
                height: props.height || "auto",
                ...props.style,
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 273 182"
                fill="none"
            >
                <path
                    d="M273 41.51l-10.246 135.067H95.705L106.573 41.51H273z"
                    fill="#37474F"
                />
                <path
                    d="M224.251 174.713l32.603-142.829-68.931-14.593-39.744 157.422h76.072z"
                    fill="url(#paint0_linear_575_1958)"
                />
                <path
                    d="M134.136.834l89.9 15.852-29.116 152.749-89.9-3.479L134.136.834z"
                    fill="url(#paint1_linear_575_1958)"
                />
                <path
                    d="M104.503 173.183V67.086h59.975l10.246-15.525h63.032l26.376 103.885-1.9 20.904-157.729-3.167z"
                    fill="#00392C"
                    opacity=".27"
                    filter="url(#filter0_f_575_1958)"
                />
                <path
                    d="M95.705 176.576L70.245 75.043h89.112l10.247-15.525h63.031l30.118 117.058H95.705z"
                    fill="url(#paint2_linear_575_1958)"
                />
                <path
                    d="M94.26 114.022h48.438c1.2 0 2.275.968 2.4 2.162.126 1.193-.745 2.161-1.946 2.161H94.714c-1.2 0-2.275-.968-2.4-2.161-.126-1.194.746-2.162 1.946-2.162z"
                    fill="#fff"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M111.768 89.935c.125 1.194-.746 2.162-1.947 2.162H89.018c-1.2 0-2.275-.968-2.4-2.162-.126-1.194.745-2.161 1.946-2.161h20.803c1.2 0 2.275.968 2.401 2.161z"
                    fill="#fff"
                />
                <path
                    d="M137.456 105.759H92.123c-1.2 0-2.275-.968-2.4-2.162-.126-1.193.745-2.161 1.946-2.161H137c1.201 0 2.276.968 2.401 2.161.126 1.194-.746 2.162-1.946 2.162z"
                    fill="#fff"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M26.21 116.114l12.62-12.62 4.4 4.401-12.62 12.62-4.4-4.401z"
                    fill="#37474F"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M43.23 103.494c13.082 13.082 34.292 13.082 47.373 0 13.082-13.081 13.082-34.29 0-47.372-13.081-13.081-34.29-13.081-47.372 0-13.082 13.082-13.082 34.29 0 47.372zm-3.105 3.107c14.797 14.797 38.787 14.797 53.585 0 14.797-14.797 14.797-38.788 0-53.585-14.798-14.797-38.788-14.797-53.585 0-14.798 14.797-14.798 38.788 0 53.585zM3.883 142.842a5.491 5.491 0 0 1 0-7.766l17.474-17.474a5.491 5.491 0 0 1 7.766 7.766l-17.474 17.474a5.492 5.492 0 0 1-7.766 0z"
                    fill="#37474F"
                />
                <defs>
                    <filter
                        id="filter0_f_575_1958"
                        x="99.503"
                        y="46.561"
                        width="169.629"
                        height="134.789"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                    >
                        <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                        />
                        <feBlend
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                        />
                        <feGaussianBlur
                            stdDeviation="2.5"
                            result="effect1_foregroundBlur_575_1958"
                        />
                    </filter>
                    <linearGradient
                        id="paint0_linear_575_1958"
                        x1="266.5"
                        y1="44"
                        x2="155.5"
                        y2="53.5"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#C7C7C7" />
                        <stop offset="1" stop-color="#616161" />
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_575_1958"
                        x1="116"
                        y1="-29.5"
                        x2="149.97"
                        y2="173.882"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#fff" />
                        <stop offset="1" stop-color="#999" />
                    </linearGradient>
                    <linearGradient
                        id="paint2_linear_575_1958"
                        x1="26"
                        y1="53.5"
                        x2="305.5"
                        y2="197.5"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stop-color="#fff" />
                        <stop offset="1" stop-color="#37474F" />
                    </linearGradient>
                </defs>
            </svg>
        </SvgIcon>
    );
};

export default NotDataIcon;
